import { transformToAnalyticsParams } from 'shared/infra/analytics';
import Amplitude from 'tools/amplitude/amplitude';

import type { LogPrinterCampaignParams } from './analytics.model';

function logPrinterCampaign(params: LogPrinterCampaignParams) {
  const transformedParams = transformToAnalyticsParams(params);
  Amplitude.logEvent('PRINTER_CAMPAIGN', transformedParams);
}

export const printerAnalytics = {
  logPrinterCampaign,
};
